<template>
    <div class="box-loading" :style="'height:' + height + 'px;'">
        <div class="inner">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path fill="none" stroke="#000000" stroke-width="10" d="M507.42 114.49c-2.34-9.47-9.66-16.98-19.06-19.61-9.47-2.61-19.65 0-26.65 6.98l-63.87 63.87-44.25-7.36-7.38-44.24 63.87-63.87c6.94-6.92 9.62-17.09 7-26.54-2.62-9.47-10.19-16.83-19.75-19.2C345.6-8.31 291.95 6.54 254.14 44.3c-37.84 37.87-52.21 92.52-38.62 144.7L22.19 382.29c-29.59 29.63-29.59 77.83 0 107.45C36.54 504.09 55.63 512 75.94 512s39.37-7.91 53.71-22.26l193.14-193.11c52.03 13.73 106.8-.72 144.89-38.82 37.81-37.81 52.68-91.39 39.74-143.32zm-62.36 120.7c-31.87 31.81-78.43 42.63-121.77 28.23l-9.38-3.14-206.88 206.84c-16.62 16.62-45.59 16.62-62.21 0-17.12-17.14-17.12-45.06 0-62.21l207.01-206.98-3.09-9.34c-14.31-43.45-3.56-90.06 28.03-121.67C299.48 44.2 329.44 32 360.56 32c6.87 0 13.81.59 20.72 1.81l-69.31 69.35 13.81 83.02L408.84 200l69.3-69.35c6.72 38.25-5.34 76.79-33.08 104.54zM80 416c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16z"/>
            </svg>
            <div class="text">
                Indlæser ...
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "../../styles/vars.scss";

    @keyframes drawStroke {
        50% {
            stroke-dashoffset: 0;
        }
        100% {
            stroke-dashoffset: 1800;
        }
    }

    .box-loading {
        height: 350px;
        display: flex;
        justify-content: center;
        align-items: center;
        animation: fadeIn 0.3s ease-in-out forwards;
        font-family: $fontfamily--main;
        font-size: 20px;
        text-align: center;

        .inner {
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        svg {
            width: 80px;
            display: block;
            overflow: unset;

            path {
                stroke: $color--dark;
                stroke-dasharray: 1800;
                stroke-dashoffset: 1800;
                animation: drawStroke 3s ease-in-out infinite;
            }
        }
    }

</style>

<script>
export default {
    props: ['height']
}
</script>



// WEBPACK FOOTER //
// BoxLoading.vue?05aecb72